import { UIElement } from '../ui-element';
import { Component } from '../../decorators/component.decorator';
import { Attribute } from '../../decorators/attribute.decorator';
import styles from './ui-griditem.css';

/**
 * @class
 * @memberof SharedComponents
 * @augments {UIElement}
 * @alias UIGridItem
 * @element ui-griditem
 * @classdesc Represents a class for <code>ui-griditem</code> element.
 * This element is done for styling grid item inside grid layout.
 * @property {("default" | "account")} [layout] {@attr layout} Layout type.
 *  {@desc account}
 * @slot
 * @example
 * <ui-grid>
 *   <ui-griditem layout="account"></ui-griditem>
 *   <ui-griditem layout="account"></ui-griditem>
 * </ui-grid>
 */
@Component({ tag: 'ui-griditem', styles })
export class UIGridItem extends UIElement {
    @Attribute(String) layout: string = '';
}
